<template>
    <div class="myMainDiv">
        <div class="myMainView">
            <div class="stuInfoDiv" @click="routeTo('User')">
                <van-image width="60" height="60" round :src="userInfoSession.stuImg ? (globalAPI.fileApi + userInfoSession.stuImg) : avatar"></van-image>
                <div class="stuInfoDetails">
                    <p style="font-size: 16px;">{{userInfoSession.stuName}}</p>
                    <p>{{userInfoSession.userName}}</p>
                </div>
            </div>
        </div>

        <van-tabbar v-model="tabbarActive" :fixed="false" class="tabbarSticky" @change="tabbarChange">
            <van-tabbar-item icon="records-o">题库</van-tabbar-item>
            <van-tabbar-item icon="contact-o">我的</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    export default {
        name: 'Home',
        data() {
            return {
                tabbarActive: 1,
                avatar: require('../assets/img/avatar.png'),
            };
        },
        mounted() {
            var that = this;
        },
        watch: {},
        methods: {
            tabbarChange(index) {
                var that = this;
                if (index == 0) {
                    that.routeTo('');
                }
                if (index == 1) {
                    that.routeTo('User');
                }
            },
            routeTo(url, query) {
                this.$router.push({
                    path: '/' + url,
                    query: query,
                });
            },
        },
    };
</script>

<style scoped>
    .myMainDiv {
        width: 100%;
        height: 100%;
        background-image: linear-gradient(to bottom, #3ab9fe, #fff);
    }

    .myMainView {
        width: 100%;
        height: calc(100% - 50px);
        padding: 10px;
        box-sizing: border-box;
        overflow: auto;
    }

    .stuInfoDiv {
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
        display: flex;
        background: #fff;
        border-radius: 5px;
    }

    .stuInfoDetails {
        width: calc(100% - 60px);
        padding: 5px 10px;
        box-sizing: border-box;
        line-height: 25px;
    }
</style>


// WEBPACK FOOTER //
// src/views/My.vue